import React from "react";
import i18n from "i18next";

import { Icon } from "../Common/Icon";
import { downloadDocument } from "../../actions";
import termsAndConditionsEn from "../../assets/Terms_Conditions_English.pdf";
import termsAndConditionsFr from "../../assets/Terms_Conditions_French.pdf";

const TermsAndConditionsCard = () => {
  const handleDownloadTermsAndConditions = () => {
    const document = localStorage.getItem("language") === "fr" ? termsAndConditionsFr : termsAndConditionsEn;
    downloadDocument(document, i18n.t("help.termsAndConditonsManualFile"));
  };
  return (
    <div className="help__card">
      <Icon className="help__user-manual-card-icon" id="book-bookmark" />
      <div className="help__card-row">
        <span className="help__card-label">{i18n.t("help.termsAndConditonsManual")}</span>
        <button className="button" onClick={handleDownloadTermsAndConditions}>
          <Icon id="download" className="button__download-icon --middle" />
        </button>
      </div>
    </div>
  );
};

export default TermsAndConditionsCard;



// WEBPACK FOOTER //
// ./src/components/Help/TermsAndConditionsCard.js